import type { CheckedMap, DownloadTreeNode } from '~/types/download'

function selectionKey(node: DownloadTreeNode) {
  return node.downloadId?.toLocaleLowerCase?.() ?? node.id?.toLocaleLowerCase?.() ?? null
}

export function generatePdfToc(toc: DownloadTreeNode[], checkedItems: CheckedMap): DownloadTreeNode[] {
  const filterToc = (items: DownloadTreeNode[]): DownloadTreeNode[] => {
    return items.reduce<DownloadTreeNode[]>((acc, item) => {
      const key = selectionKey(item)
      const isChecked = !!(key && checkedItems.has(key))

      // Recursively filter children if they exist
      const filteredChildren = item.children && item.children.length > 0
        ? filterToc(item.children)
        : []

      // Include item if:
      // 1. It's checked itself, OR
      // 2. It has children that passed the filter (to maintain structure)
      if (isChecked || filteredChildren.length > 0) {
        acc.push({
          ...item,
          children: filteredChildren,
        })
      }

      return acc
    }, [])
  }

  return filterToc(toc)
}
